import { useEffect, useState } from "react";
import { Table, Button, Select, Spin, Modal, message, Typography, Space } from "antd";
import type { TableColumnsType, TableProps } from "antd";
import axios from "axios";
import {
  ResponseAPI,
  OptionFilterItem,
  FilterCombustion,
  CombustionVocEmission,
  Month,
  SummaryVocEmission,
  Master,
  Option,
  ApproveBody,
  WidthCol,
  UnitCombustionVoc,
  WidthColCombustion,
} from "src/entity/report-voc-emission/report-voc-emission.entity";
import {
  getOptionsFilterReportVocEmission,
  getReportVocEmission,
  getOptionMonthSubmit,
  submitReportVoc,
  updateApproveStep,
} from "src/services/combustion.service";
import { BsTable } from "react-icons/bs";
import { getMaster } from "src/services/master.service";
import { HiOutlineClipboardDocumentCheck } from "react-icons/hi2";
import { PiChartBarFill } from "react-icons/pi";
import { componentPalette } from "src/theme/component-palette";
import { useShallow } from "zustand/react/shallow";
import { profileStore } from "src/stores/profile-store";
import { canApproveAndViewTable, roleCompanyAdmin } from "../../PermissionCheck/PermissionCheck";
import "./ReportVocEmissionTable.css";
import { useSearchParams } from "react-router-dom";
import { EmptyString, UnitAllEnum } from "src/entity/common/unit.constant";
import { CommonError, CommonSuccess } from "src/entity/common/menus-enum.enum";
import { excelStore } from "src/stores/excel-store.interface";
import ModalApproveMonth from "src/components/ModalApproveMonth/ModalApproveMonth";
import ModalApproveStep from "src/components/ModalApproveStep/ModalApproveStep";
import { DataApprove, OptionApproval } from "src/entity/voc-approve/voc-approve.entity";
import { TbRefresh } from "react-icons/tb";
import useNavigationMenu from "src/hook/useNavigationMenu";
import { CloseOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { formatNumber, parseAndFormatScientificNumber, parseToFixedDecimalWithComma } from "src/utils/process-number";
import { generateYearArray } from "src/utils/array";
import { getInfoStepApproval, getOptionVocApproval } from "src/services/voc-approval";
import { convertEmissionWord } from "src/entity/common/global.entity";
import { utilsStore } from "src/stores/utils-store";
import { addCenterAlign } from "src/components/AntdCustomPart/TableTitle.tsx/TableTitle";

const { Text } = Typography;

const ReportFuelVolumeTable = () => {
  const menu = "combustion";
  const [messageApi, contextHolder] = message.useMessage();
  const profile = profileStore(useShallow((state) => state.profile));
  const { permissions } = useNavigationMenu();
  const [companyId, setCompanyId] = useState<string>("");
  const currentYear = new Date().getFullYear();
  const userId = profile?.userId;
  const email = profile?.email;
  const name = profile?.name;

  const getTextWidth = utilsStore(useShallow((state) => state.getTextWidth));

  const [searchParams] = useSearchParams();
  const yearParam = searchParams.get("year");
  const monthParam = searchParams.get("month");
  const approveNoParam = searchParams.get("approveNo");
  const companyParam = searchParams.get("companyId");

  const [data, setData] = useState<CombustionVocEmission[]>();
  const [dataAllUnit, setDataAllUnit] = useState<UnitCombustionVoc>();
  const [summary, setSummary] = useState<SummaryVocEmission[]>();
  const [optionYears, setOptionYears] = useState<number[]>([]);
  const [selectedYear, setSelectedYear] = useState<number | null>(null);
  const [loading, setLoading] = useState(false);
  const [filterLoading, setFilterLoading] = useState(false);
  const [current, setCurrent] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [filterStackId, setFilterStackId] = useState<number[]>();
  const [filterSourceId, setFilterSourceId] = useState<number[]>();
  const [filterArea, setFilterArea] = useState<string[]>();
  const [filterFuelName, setFilterFuelName] = useState<string[]>();
  const [filterCombustion, setFilterCombustion] = useState<FilterCombustion>({
    stackId: null,
    sourceId: null,
    area: null,
    fuelName: null,
  });
  const [optionEmissions, setOptionEmissions] = useState<Option[]>([]);
  const [selectedEmission, setSelectedEmission] = useState<string>("tvoc");
  const [selectedButton, setSelectedButton] = useState<string>("table");
  const [openModalApproveMonth, setOpenModalApproveMonth] = useState<boolean>(false);
  const [optionMonth, setOptionMonth] = useState<Option[]>([]);
  const [optionApprove, setOptionApprove] = useState<Option[]>([]);
  const [selectedApprove, setSelectedApprove] = useState<string>();
  const [approveData, setApproveData] = useState<DataApprove | null>(null);

  // For new ui approval page
  const [optionApproval, setOptionApproval] = useState<OptionApproval | null>();
  const [selectedYearApprove, setSelectedYearApprove] = useState<number | null>();
  const [selectedMonthApprove, setSelectedMonthApprove] = useState<string | null>();
  const [selectedNoApprove, setSelectedNoApprove] = useState<number | null>();

  const [openModalApproveStep, setOpenModalApproveStep] = useState<boolean>(false);
  const [widthMainColumns, setWidthMainColumnsl] = useState<WidthColCombustion>({});
  const [widthTotal, setWidthTotal] = useState<string>("");
  const [widthCol, setWidthCol] = useState<WidthCol>({
    jan: "",
    feb: "",
    mar: "",
    apr: "",
    may: "",
    jun: "",
    jul: "",
    aug: "",
    sep: "",
    oct: "",
    nov: "",
    dec: "",
  });
  const excelSetSelectedYear = excelStore(useShallow((state) => state.setSelectedYear));
  const excelSetQueryStr = excelStore(useShallow((state) => state.setQueryStr));
  const [selectedUnit, setSelectedUnit] = useState<string>(UnitAllEnum.KG);

  const fetchYear = () => {
    const years = generateYearArray();
    setOptionYears(years as number[]);
    setSelectedYear(years[0] as number);
  };

  const warningAlert = (message: string | string[], action: string) => {
    const warnModal = Modal.confirm({
      title: (
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <span>Can not {action}</span>
          <CloseOutlined onClick={() => warnModal.destroy()} style={{ cursor: "pointer" }} />
        </div>
      ),
      content: message,
      okText: "OK",
      icon: <InfoCircleOutlined style={{ color: componentPalette.redThird }} />,
      okButtonProps: { style: { textAlign: "center", backgroundColor: componentPalette.primary } },
      cancelButtonProps: { style: { display: "none" } },
      onOk: () => {},
      className: "custom-tmp-modal-warning",
    });
  };

  const calPagination = (current?: number) => {
    if (current) {
      return (current - 1) * 10;
    }
  };

  const createParamFilter = (type: "fetch" | "export") => {
    let queryParam = "";
    const emissionFilter = selectedEmission;

    if (selectedYear) {
      queryParam += `year=${selectedYear}`;
    }

    queryParam += `&emission=${emissionFilter}`;
    queryParam += `&unit=${selectedUnit}`;

    if (filterCombustion) {
      const str = Object.entries(filterCombustion)
        .filter(([_, value]) => value != null && value.length > 0)
        .map(([key, value]) => `&${key}=[${[value.join(",")]}]`)
        .join("");
      queryParam += str;
    }

    return queryParam;
  };

  const fetchCombustions = async () => {
    try {
      if (companyId) {
        setLoading(true);
        let offset = 0;
        let resultCalOffset = calPagination(current);
        if (resultCalOffset) {
          offset = resultCalOffset;
        }
        const queryParam = createParamFilter("fetch");
        if (selectedYear) {
          let response = await getReportVocEmission(companyId, queryParam);
          if (response.data.code === 200) {
            setLoading(false);
            setDataAllUnit(response.data.data);
          }
        }
      }
    } catch (error: any) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const fetchOptionFilterCombustions = async () => {
    try {
      if (companyId) {
        let query = `year=${selectedYear}&emission=tvoc`;
        let response = await getOptionsFilterReportVocEmission(companyId, query);
        let responseData: ResponseAPI = response.data;
        if (responseData.code === 200) {
          setLoading(false);
          const filter = response.data.data.filter;
          if (filter.length > 0) {
            setFilterStackId(filter.find((item: OptionFilterItem) => item.key === "stackId")?.filter ?? []);
            setFilterSourceId(filter.find((item: OptionFilterItem) => item.key === "sourceId")?.filter ?? []);
            setFilterArea(filter.find((item: OptionFilterItem) => item.key === "area")?.filter ?? []);
            setFilterFuelName(filter.find((item: OptionFilterItem) => item.key === "fuelName")?.filter ?? []);
          } else {
            setFilterStackId([]);
            setFilterSourceId([]);
            setFilterArea([]);
            setFilterFuelName([]);
          }
        }
      }
    } catch (error: any) {
      console.error(error);
    }
  };

  const getMainColumnsWidth = (
    fontSize = "14px",
    fontFamily = "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'",
  ) => {
    const font = `${fontSize} ${fontFamily}`;
    const widthMainColumnsTmp: { [key in keyof CombustionVocEmission]: string } = {} as any;
    const mainColumns = ["stackId", "sourceId", "area", "fuelName", "emission", "unit"];

    if (data && data.length > 0) {
      mainColumns.forEach((column) => {
        let max = 0;

        data.forEach((row) => {
          const text = String(row[column as keyof CombustionVocEmission] ?? "");
          const textWidth = getTextWidth(text, font);
          if (textWidth > max) max = textWidth;
        });
        if (max < 50) max = 100;
        widthMainColumnsTmp[column as keyof typeof widthMainColumnsTmp] = `${max * 1.1}px`;
      });
    }
    setWidthMainColumnsl(widthMainColumnsTmp);
  };

  const getWidth = (
    fontSize = "14px",
    fontFamily = "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'",
  ) => {
    const font = `${fontSize} ${fontFamily}`;
    const widthMonth: { [key in keyof SummaryVocEmission]: string } = {} as any;
    months.forEach((month) => {
      const keyMonth = month.dataIndex as keyof SummaryVocEmission;

      const widthAb = summary?.[0]?.[keyMonth] || "";
      const widthIn = summary?.[1]?.[keyMonth] || "";

      const textWidthAb = getTextWidth(String(widthAb), font);
      const textWidthIn = getTextWidth(String(widthIn), font);

      let maxWidth = Math.max(textWidthAb, textWidthIn);

      if (maxWidth < 90) {
        maxWidth = 90;
      }

      widthMonth[keyMonth] = `${maxWidth}px`;
    });

    setWidthCol(widthMonth);
    const widthTotalAb = summary?.[0]?.total || "";
    const widthTotalIn = summary?.[1]?.total || "";
    const textWidthTotalAb = getTextWidth(String(widthTotalAb), font);
    const textWidthTotalIn = getTextWidth(String(widthTotalIn), font);
    let maxWidthTotal = Math.max(textWidthTotalAb, textWidthTotalIn);
    if (maxWidthTotal == 0) {
      maxWidthTotal = 100;
    }
    setWidthTotal(`${maxWidthTotal}px`);
  };

  const fetchMasterData = async () => {
    try {
      const response = await getMaster();
      if (response.data.code === 200) {
        const master: Master[] = response.data.data;

        const emissions = master.find((item) => item.label === "Emission");

        if (emissions?.options) {
          setOptionEmissions(emissions?.options);
          setSelectedEmission(emissions?.options[0].value);
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  const fetchMonthOfSubmit = async () => {
    try {
      if (selectedYear && companyId) {
        setFilterLoading(true);
        const response = await getOptionMonthSubmit(companyId, selectedYear);
        if (response.data.code === 200) {
          const month = response.data.data;
          setOptionMonth(month);
        } else {
          setOptionMonth([]);
        }
      }
    } catch (error) {
      console.error(error);
      setOptionMonth([]);
    } finally {
      setFilterLoading(false);
    }
  };

  const fetchOptionVocApprove = async () => {
    try {
      if (companyId) {
        if (yearParam && !selectedYearApprove && !selectedMonthApprove) return;

        const queryParams = new URLSearchParams({ menu });
        if (selectedYearApprove) {
          queryParams.append("year", selectedYearApprove.toString());
        }
        if (selectedMonthApprove) {
          queryParams.append("month", selectedMonthApprove);
        }

        const queryString = queryParams.toString();
        const response = await getOptionVocApproval(queryString);
        if (response.data.code === 200) {
          const { approveNo } = response.data.data || {};
          setOptionApproval({ ...response.data.data });

          if (approveNo) {
            if (!selectedNoApprove && selectedYearApprove && selectedMonthApprove && approveNo?.length === 1) {
              setSelectedNoApprove(approveNo[0]);
            }
          } else {
            resetSelections();
          }
        } else {
          resetSelections();
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  const resetApprovalState = () => {
    setApproveData(null);
    setSelectedApprove("");
  };

  const fetchInfoStepApprove = async () => {
    try {
      if (companyId && selectedYearApprove && selectedMonthApprove && selectedNoApprove) {
        setLoading(true);
        if (selectedYearApprove && selectedMonthApprove && selectedNoApprove) {
          const query = new URLSearchParams({
            menu,
            year: selectedYearApprove.toString(),
            month: selectedMonthApprove,
            approveNo: selectedNoApprove.toString(),
          }).toString();
          const response = await getInfoStepApproval(query);
          if (response.data.code === 200) {
            const approveInfo = response.data.data;
            setApproveData(approveInfo);
            setSelectedApprove(approveInfo._id || "");
          } else {
            setApproveData(null);
            resetApprovalState();
          }
        } else {
          setApproveData(null);
        }
      } else {
        resetApprovalState();
      }
    } catch (error) {
      console.error("Error fetching approval data:", error);
      resetApprovalState();
    } finally {
      setLoading(false);
    }
  };

  const resetSelections = () => {
    setOptionApproval(null);
    setSelectedYearApprove(null);
    setSelectedMonthApprove(null);
    setSelectedNoApprove(null);
  };

  const handleYearChange = (value: number) => {
    setSelectedYear(value);
  };

  const handleChangeEmission = (value: string) => {
    setSelectedEmission(value);
  };

  const handleButtonMenuClick = (buttonName: string) => {
    setSelectedButton(buttonName);
    if (buttonName === "table") {
      setOpenModalApproveStep(false);
      if (yearParam && monthParam && approveNoParam) {
        searchParams.delete("yearParam");
        searchParams.delete("monthParam");
        searchParams.delete("approveNoParam");
        searchParams.delete("companyId");
      }
    } else if (buttonName === "approve") {
      fetchOptionVocApprove();
      setOpenModalApproveStep(true);
      if (yearParam) setSelectedYearApprove(Number(yearParam));
    }
  };

  const handleOpenModalApproveMonth = () => {
    setOpenModalApproveMonth(true);
  };

  const handleSubmitReport = async (checkMonths: any) => {
    try {
      if (companyId && userId) {
        const payload = {
          userId: userId,
          months: checkMonths,
          year: selectedYear,
        };
        setLoading(true);
        const response = await submitReportVoc(companyId, payload);
        if (response.data.code === 200) {
          setOpenModalApproveMonth(false);
          setLoading(false);
          messageApi.open({
            type: "success",
            content: CommonSuccess.SUBMIT_SUCCESSFULL,
          });
          fetchMonthOfSubmit();
        } else {
          messageApi.open({
            type: "error",
            content: CommonError.SUBMIT_FAIL,
          });
        }
      }
    } catch (error) {
      setLoading(false);
      if (axios.isAxiosError(error)) {
        const responseData = error?.response?.data as ResponseAPI;
        if (error?.response?.status === 400) {
          warningAlert(String(responseData.message), "submit");
        } else {
          messageApi.open({
            type: "error",
            content: CommonError.SUBMIT_FAIL,
          });
        }
      }
    } finally {
      setLoading(false);
    }
  };

  const handleApproveReport = async (approveBody: ApproveBody, action: string) => {
    try {
      if (companyId) {
        setLoading(true);
        const response = await updateApproveStep(companyId, approveBody);
        if (response.data.code == 200) {
          if (action === "approved") {
            messageApi.open({
              type: "success",
              content: CommonSuccess.APPROVED_SUCCESSFULL,
            });
          } else if (action === "reject") {
            messageApi.open({
              type: "success",
              content: CommonSuccess.REJECT_SUCCESSFULL,
            });
          }
          await fetchInfoStepApprove();
          await fetchMonthOfSubmit();
        } else {
          messageApi.open({
            type: "error",
            content: CommonError.APPROVED_FAIL,
          });
        }
      }
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const responseData = error?.response?.data as ResponseAPI;
        const actionStr = action === "approved" ? "approve" : "reject";
        if (error?.response?.status === 400) {
          warningAlert(String(responseData.message), actionStr);
        } else {
          messageApi.open({
            type: "error",
            content: CommonError.APPROVED_FAIL,
          });
        }
      }
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleChangeApprove = (value: string) => {
    setSelectedApprove(value);
  };

  const exportExel = async () => {
    const token = localStorage.getItem("auth-token");
    if (selectedYear) {
      const queryParam = createParamFilter("export");
      axios({
        method: "get",
        url: `${process.env.REACT_APP_BASE_URL}api/combustion/report/voc-emission/export-excel/${companyId}?${queryParam}`,
        responseType: "blob",
        headers: {
          Authorization: "Bearer " + token,
        },
      })
        .then((response) => {
          const link: any = document.createElement("a");
          link.href = window.URL.createObjectURL(new Blob([response.data], { type: "application/xlsx" }));
          const fileName = `VocEmission-Report-${selectedYear}.xlsx`;
          link.download = fileName;
          document.body.appendChild(link);

          link.click();
          setTimeout(function () {
            window.URL.revokeObjectURL(link);
          }, 200);
        })
        .catch(() => {
          messageApi.open({
            type: "error",
            content: CommonError.SOMETHING_WRONG,
          });
        });
    }
  };

  const onTableChange: TableProps<CombustionVocEmission>["onChange"] = (pagination: any, filters, sorter, extra) => {
    setFilterCombustion((prevState) => ({
      ...prevState,
      ...filters,
    }));
    setCurrent(pagination.current);
    setPageSize(pagination.pageSize);
  };

  const resetFilter = () => {
    setFilterCombustion((prevState) => ({
      ...prevState,
      stackId: null,
      sourceId: null,
      area: null,
      fuelName: null,
    }));
  };

  const handleYearApproveChange = (value: number) => {
    setSelectedYearApprove(value);
    setSelectedMonthApprove(null);
    setSelectedNoApprove(null);
  };

  const handleMonthApprovalChange = (value: string) => {
    setSelectedMonthApprove(value);
    setSelectedNoApprove(null);
  };

  const handleApproveNoChange = (value: number) => {
    setSelectedNoApprove(value);
  };

  const handleChangeUnit = () => {
    if (selectedUnit === UnitAllEnum.KG) {
      setSelectedUnit(UnitAllEnum.TON);
    } else if (selectedUnit === UnitAllEnum.TON) {
      setSelectedUnit(UnitAllEnum.KG);
    }
  };

  const removeSarchParam = () => {
    searchParams.delete("year");
    searchParams.delete("month");
    searchParams.delete("approveNo");
    searchParams.delete("companyId");
  };

  useEffect(() => {
    getWidth();
  }, [summary]);

  useEffect(() => {
    getMainColumnsWidth();
  }, [data]);

  useEffect(() => {
    if (dataAllUnit && selectedUnit) {
      const dataUnitSelected = dataAllUnit[selectedUnit];
      if (dataUnitSelected) {
        setData(dataUnitSelected.combustions);
        setSummary(dataUnitSelected.summary);
      }
    }
  }, [dataAllUnit, selectedUnit]);

  useEffect(() => {
    fetchYear();
  }, []);

  useEffect(() => {
    if (selectedYear) {
      excelSetSelectedYear(selectedYear);
    }
  }, [selectedYear]);

  useEffect(() => {
    const queryParam = createParamFilter("export");
    if (queryParam) {
      excelSetQueryStr(queryParam);
    }
  }, [filterCombustion, selectedYear, selectedUnit, selectedEmission]);

  useEffect(() => {
    if (profile?.activeCompany?._id) {
      setCompanyId(profile.activeCompany._id);
    }
  }, [profile?.activeCompany]);

  useEffect(() => {
    const fetchData = async () => {
      if (!companyId) return;
      setSelectedYear(currentYear);
      if (yearParam && monthParam && approveNoParam) {
        if (companyId === companyParam) {
          handleButtonMenuClick("approve");
          if (yearParam) setSelectedYearApprove(Number(yearParam));
          if (monthParam) setSelectedMonthApprove(monthParam);
          if (approveNoParam) setSelectedNoApprove(Number(approveNoParam));
          removeSarchParam();
        }
      } else if (yearParam) {
        // Case: Redirected from "My Task" to the VOC Emission report with only the year parameter
        if (yearParam) setSelectedYear(Number(yearParam));
        if (Number(yearParam) === Number(selectedYear)) {
          searchParams.delete("year");
        }
      } else {
        setSelectedYearApprove(null);
        setSelectedMonthApprove(null);
        setSelectedNoApprove(null);
      }

      fetchMasterData();
      fetchMonthOfSubmit();
      fetchOptionVocApprove();
      await Promise.all([
        fetchMasterData,
        fetchMonthOfSubmit(),
        fetchOptionVocApprove(),
        fetchCombustions(),
        fetchOptionFilterCombustions(),
      ]);
    };

    fetchData();
  }, [companyId]);

  useEffect(() => {
    resetFilter();
  }, [selectedYear]);

  useEffect(() => {
    fetchMonthOfSubmit();
  }, [selectedYear, companyId]);

  useEffect(() => {
    if (selectedYear) {
      const fetchData = async () => {
        await fetchCombustions();
        await fetchOptionFilterCombustions();
      };

      fetchData();
    }
  }, [current, filterCombustion, selectedEmission]);

  useEffect(() => {
    fetchOptionVocApprove();
    fetchInfoStepApprove();
  }, [selectedYearApprove, selectedMonthApprove, selectedNoApprove]);

  const isDisableSubmitButton = () => {
    if (loading || !permissions || !data) return true;
    if (!canApproveAndViewTable(permissions) || data?.length == 0 || optionMonth.length === 0) {
      return true;
    } else {
      return false;
    }
  };

  const buttonStyle = (buttonName: string) => ({
    backgroundColor: selectedButton === buttonName ? componentPalette.primary : "initial",
    color: selectedButton === buttonName ? "white" : "initial",
  });

  const months: Month[] = [
    { title: "Jan", dataIndex: "jan" },
    { title: "Feb", dataIndex: "feb" },
    { title: "Mar", dataIndex: "mar" },
    { title: "Apr", dataIndex: "apr" },
    { title: "May", dataIndex: "may" },
    { title: "Jun", dataIndex: "jun" },
    { title: "Jul", dataIndex: "jul" },
    { title: "Aug", dataIndex: "aug" },
    { title: "Sep", dataIndex: "sep" },
    { title: "Oct", dataIndex: "oct" },
    { title: "Nov", dataIndex: "nov" },
    { title: "Dec", dataIndex: "dec" },
  ];

  const monthColumns: TableColumnsType<CombustionVocEmission> = months.map((month) => ({
    title: month.title,
    width: widthCol[month.dataIndex as keyof WidthCol],
    render: (_, record) => {
      if (record && typeof record === "object") {
        const value = record[month.dataIndex];
        if (typeof value === "number") {
          return value ? <Text>{parseAndFormatScientificNumber(`${value}`, 2)}</Text> : <Text>0</Text>;
        } else {
          return <Text>0</Text>;
        }
      }
    },
  }));

  const staticColumns: TableColumnsType<CombustionVocEmission> = [
    {
      title: "Stack ID",
      dataIndex: "stackId",
      width: widthMainColumns?.stackId,
      filteredValue: filterCombustion?.stackId || null,
      filters: filterStackId?.map((el: number) => ({ text: el, value: el })),
      render: (text) => <Text>{text}</Text>,
    },
    {
      title: "Source ID",
      dataIndex: "sourceId",
      width: widthMainColumns?.sourceId,
      filteredValue: filterCombustion?.sourceId || null,
      filters: filterSourceId?.map((el: number) => ({ text: el, value: el })),
      render: (text) => <Text>{text}</Text>,
    },
    {
      title: "Area",
      dataIndex: "area",
      width: widthMainColumns?.area,
      filteredValue: filterCombustion?.area || null,
      filters: filterArea?.map((el: string) => ({ text: el, value: el })),
      render: (text) => <Text>{text}</Text>,
    },
    {
      title: "Fuel Name",
      dataIndex: "fuelName",
      width: widthMainColumns?.fuelName,
      filteredValue: filterCombustion?.fuelName || null,
      filters: filterFuelName?.map((el: string) => ({ text: el === EmptyString ? "" : el, value: el })),
      render: (text) => <Text>{text}</Text>,
    },
    {
      title: "Emission",
      dataIndex: "emission",
      width: widthMainColumns?.fuelName,
      render: (value) => {
        return value ? <Text>{value.toUpperCase() + `${value == "tvoc" ? "s" : ""}`}</Text> : value;
      },
    },
    {
      title: (
        <>
          <Space>
            Unit
            <Button onClick={handleChangeUnit} type="text" icon={<TbRefresh />} />
          </Space>
        </>
      ),
      dataIndex: "unit",
      width: 80,
      render: (text) => <Text>{text}</Text>,
    },
  ];

  const totalColumns: TableColumnsType<CombustionVocEmission> = [
    {
      title: "Total",
      dataIndex: "total",
      width: widthTotal,
      render: (value) => {
        if (typeof value === "number") {
          return value ? <Text>{parseAndFormatScientificNumber(`${value}`, 2)}</Text> : 0;
        } else {
          return 0;
        }
      },
    },
  ];

  const columns: TableColumnsType<CombustionVocEmission> = [...staticColumns, ...monthColumns, ...totalColumns];

  return (
    <>
      {contextHolder}

      <div style={{ display: "flex", paddingBottom: "10px", gap: "20px", position: "relative" }}>
        <div>
          <div style={{ display: "flex", gap: "20px" }}>
            {selectedButton === "table" ? (
              <Select
                value={selectedYear}
                style={{ width: 120 }}
                onChange={handleYearChange}
                options={optionYears.map((year) => ({ label: year, value: year }))}
                loading={loading}
                size="middle"
              />
            ) : (
              <div style={{ display: "flex", gap: "10px" }}>
                <Select
                  value={selectedYearApprove}
                  style={{ width: 120 }}
                  onChange={handleYearApproveChange}
                  options={optionApproval?.year?.map((year) => ({ label: year, value: year }))}
                  loading={loading}
                  size="middle"
                />
                <Select
                  value={selectedMonthApprove}
                  style={{ width: 120 }}
                  onChange={handleMonthApprovalChange}
                  options={optionApproval?.month?.map((month) => ({ label: month.charAt(0).toUpperCase() + month.slice(1), value: month }))}
                  loading={loading}
                  size="middle"
                />
                <Select
                  value={selectedNoApprove}
                  style={{ width: 120 }}
                  onChange={handleApproveNoChange}
                  options={optionApproval?.approveNo?.map((approveNo) => ({ label: approveNo, value: approveNo }))}
                  loading={loading}
                  size="middle"
                />
              </div>
            )}

            {/* Emission Select */}
            {selectedButton === "table" && (
              <Select
                value={selectedEmission}
                style={{
                  width: 120,
                  visibility: selectedButton === "table" ? "visible" : "hidden",
                }}
                onChange={handleChangeEmission}
                options={optionEmissions}
                loading={loading}
                size="middle"
              />
            )}
          </div>
        </div>

        <div style={{ display: "flex", gap: "10px" }}>
          <Button
            size="middle"
            style={buttonStyle("table")}
            icon={<BsTable style={{ fontSize: "18px" }} />}
            onClick={() => handleButtonMenuClick("table")}
          />
          <Button
            size="middle"
            style={buttonStyle("chart")}
            icon={<PiChartBarFill style={{ fontSize: "18px" }} />}
            onClick={() => handleButtonMenuClick("chart")}
          />
          <Button
            size="middle"
            style={buttonStyle("approve")}
            icon={<HiOutlineClipboardDocumentCheck style={{ fontSize: "18px" }} />}
            onClick={() => handleButtonMenuClick("approve")}
          />
        </div>
      </div>

      {selectedButton === "table" && (
        <Table
          className="w-full mt-4"
          style={{ whiteSpace: "nowrap" }}
          columns={addCenterAlign(columns)}
          dataSource={canApproveAndViewTable(permissions) ? data : []}
          onChange={onTableChange}
          rowKey="_id"
          scroll={{ x: "max-content", y: data?.length === 0 ? "auto" : 500 }}
          loading={loading || filterLoading}
          pagination={false}
          summary={(pageData) => {
            if (pageData.length > 0) {
              return (
                <Table.Summary fixed="bottom">
                  {summary?.map((row, index) => (
                    <Table.Summary.Row>
                      <Table.Summary.Cell index={0} colSpan={4}>
                        <div style={{ textAlign: "center" }}>
                          <Text>{row.label}</Text>
                        </div>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={1} colSpan={1}>
                        <div style={{ textAlign: "left" }}>
                          <Text>{row.emission ? convertEmissionWord(row.emission.toUpperCase()) : convertEmissionWord(row.emission)}</Text>
                        </div>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={2} colSpan={1}>
                        <div style={{ textAlign: "left" }}>
                          <Text>{row.unit}</Text>
                        </div>
                      </Table.Summary.Cell>
                      {months.map((month, idxMonth) => {
                        const keyMonth = month.dataIndex;
                        const total = row[keyMonth as keyof typeof row] as number;
                        return (
                          <>
                            <Table.Summary.Cell index={idxMonth + index} colSpan={1} className="summary-cell">
                              {/* <Text> {total ? formatNumber(total) : 0}</Text> */}
                              <Text>
                                {total
                                  ? row.key === "intensity"
                                    ? parseAndFormatScientificNumber(`${total}`, 2)
                                    : parseAndFormatScientificNumber(`${total}`, 2)
                                  : 0}
                              </Text>
                            </Table.Summary.Cell>
                          </>
                        );
                      })}
                      <Table.Summary.Cell index={19} colSpan={1}>
                        <Text>
                          {row.total
                            ? row.key === "intensity"
                              ? parseAndFormatScientificNumber(`${row.total}`, 2)
                              : parseAndFormatScientificNumber(`${row.total}`, 2)
                            : 0}
                        </Text>
                        {/* <Text>{row.total ? formatNumber(row.total) : 0}</Text> */}
                      </Table.Summary.Cell>
                    </Table.Summary.Row>
                  ))}
                </Table.Summary>
              );
            }
          }}
        />
      )}
      <div style={{ paddingTop: "20px", justifyContent: "flex-end", display: "flex" }}>
        {selectedButton == "table" && profile?.roles.includes(roleCompanyAdmin) && (
          <Button type="primary" style={{}} onClick={handleOpenModalApproveMonth} disabled={isDisableSubmitButton()}>
            Submit
          </Button>
        )}
      </div>
      {openModalApproveMonth && (
        <ModalApproveMonth
          open={openModalApproveMonth}
          intitailMonthly={optionMonth}
          loading={loading || filterLoading}
          onSubmitReport={(checkedMonths) => {
            handleSubmitReport(checkedMonths);
          }}
          onCancelReport={() => {
            setOpenModalApproveMonth(false);
          }}
        />
      )}

      {openModalApproveStep && approveData && userId && selectedApprove && email && name && (
        <>
          {loading || filterLoading ? (
            <Spin style={{ display: "flex", justifyContent: "center", alignItems: "center" }} />
          ) : (
            <ModalApproveStep
              data={approveData}
              userId={userId}
              approveId={selectedApprove}
              email={email}
              name={name}
              onApprove={(approveBody, action) => {
                handleApproveReport(approveBody, action);
              }}
            />
          )}
        </>
      )}
    </>
  );
};

export default ReportFuelVolumeTable;
